import { profileTh, editProfileTh } from "@/module/Profile/locale/ProfileLocaleTh.js";
import { registerTh } from "@/module/Register/locale/RegisterLocaleTh.js";
import { surpriseTh } from "@/module/SurpriseBox/locale/SurpriseLocaleTh.js";

export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
        ok: 'ตกลง',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        connection_error: 'ไม่สามารถเชื่อมต่ออินเตอร์เน็ต<br/>กรุณาลองใหม่อีกครั้ง',
        user_expire_error: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    },
    profile: profileTh,
    edit_profile: editProfileTh,
    register: registerTh,
    surprise: surpriseTh,
    otp: {
        headline: 'กรอกรหัส OTP',
        line1: 'รหัส OTP จะส่ง SMS ไปที่เบอร์',
        ref_code: 'รหัสอ้างอิง ',
        expire_in: 'รหัสจะหมดอายุภายใน ',
        second: 'วินาที',

        resend_otp: 'ขอรหัส OTP อีกครั้ง',
        err_code: 'Error Code : ',

        confirm_btn: 'ยืนยัน',
    },
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'ยืนยันการรับสิทธิ์',
        pre_msg: 'คุณยืนยันที่จะ<br/>',

        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        isLoading: 'กำลังดำเนินการ',
        default: 'กดรับสิทธิ์',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'สินค้านี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        cpfProduct: {
            button: 'เฉพาะร้านค้าเท่านั้น',
            text: 'สิทธิพิเศษนี้ต้องใช้ "รหัส”จากร้านค้าในการแลกรับ กรุณากดรับสิทธิ์ที่หน้าร้านตัวแทนจำหน่ายเท่านั้น'
        },
        marketplace: 'เพิ่มลงตะกร้า',

        alert_headline: 'กรุณาเข้าระบบ',
        alert_login_msg: 'กรุณาเข้าระบบเพื่อใช้งาน',
        alert_ok_btn: 'ตกลง'
    },
    purchase: {
        show_code: 'ดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        prepare: 'บริษัทจะจัดส่งให้ 14 วันทำการ',
        delivery: 'กำลังจัดส่ง',
        shipped: 'จัดส่งสำเร็จ',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',//'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',//''กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',//'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',//'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีที่ได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า'//'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
    },
    serial: {
        close_btn: 'ปิด',
        show_code_fix: 'กรุณาแสดง{0}นี้ให้แก่พนักงาน',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'บริษัทจะจัดส่งให้ภายใน 14 วันทำการ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล<br/>หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        passcode_txt: 'กรณีไม่มีเครื่อง EDC หรือ merchant system',
        passcode_btn: 'กรุณากรอก Passcode',

        expire_in: 'หมดอายุภายใน ',
        code_expired: 'หมดอายุ',
        code_expired_unit: ' นาที',

        // redeem_on: 'รับเมื่อ {0} เวลา {1}น.',
        redeem_on: 'รับสิทธิ์เมื่อ',

        passcode_headline: 'กรุณากรอกรหัสร้านค้า',
        passcode_sub_headline: 'ร้านค้ากรอกเพื่อยืนยันการรับสิทธิ์',

        passcode : {
            required: 'กรุณากรอก Passcode',
            too_short: 'กรุณากรอก Passcode จำนวน 5 หลัก',
            not_found: 'ข้อมูล Passcode ไม่ถูกต้อง',
            not_correct: 'ข้อมูล Passcode ไม่ถูกต้อง',
            placeholder: 'รหัสร้านค้า'
        },

        passcode_cancel: 'ยกเลิก',
        passcode_confirm: 'ยืนยัน',

        redeem_success_headline: 'รับสิทธิ์เรียบร้อยแล้ว',
        redeem_success_history: 'ดูประวัติ',
        redeem_success_close: 'ปิด',
    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',
        select_address: 'เลือกที่อยู่จัดส่ง',
        add_address: 'กรอกที่อยู่จัดส่ง',
        edit_address: 'กรอกที่อยู่จัดส่ง',
        detail_headline: 'เลือกที่อยู่จัดส่ง',
        profile_headline: 'แก้ไขที่อยู่จัดส่ง',

        detail_sub_deadline: '',
        profile_sub_headline: 'ข้อมูลในการจัดส่ง',

        add_address_btn: 'เพิ่มที่อยู่จัดส่ง',
        delete_address_btn: 'ลบ',
        edit_address_btn: 'แก้ไข',
        address_no: 'ที่อยู่',
        address_tel: 'โทร.',


        save_address_btn: 'บันทึก',

        firstname: {
            name: 'ชื่อจริง',
            placeholder: 'ชื่อจริง',
            required: 'กรุณากรอกชื่อจริง',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'ที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทร',
            placeholder: 'เบอร์โทร',
            required: 'กรุณากรอกเบอร์โทรศัพท์มือถือ',
            too_short: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
            invalid: 'เบอร์โทรศัพท์มือถือไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล์',
            placeholder: 'อีเมล์',
            required: 'กรุณากรอกอีเมล์',
            too_short: '',
            invalid: 'อีเมล์ของคุณไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'แขวง/ตำบล',
            required: 'กรุณาเลือกแขวง/ตำบล',
            too_short: '',
            invalid: '',
            name_shipping: 'ตำบล',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'เขต/อำเภอ',
            required: 'กรุณาเลือกเขต/อำเภอ',
            too_short: '',
            invalid: '',
            name_shipping: 'อำเภอ',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'จังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',

        confirm_delete_headline: 'ยืนยันลบที่อยู่',
        confirm_delete_msg: 'คุณต้องลบที่อยู่นี้ทิ้งหรือไม่',
        confirm_btn_ok: 'ยืนยัน',
        confirm_btn_cancel: 'ยกเลิก'
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้ ',
        use_point: 'ใช้ ',
    },
    detail: {
        navbar_detail_name: 'รายละเอียด',
        navbar_news_name: 'ข่าวสารและโปรโมชั่น',
        navbar_online_cate_name: 'รายละเอียด',
        navbar_title: 'คุณ',
        navbar_point: 'มี {0} คะแนน',
        nav_point: 'คะแนน',

        news_time: '{0} เวลา {1} น.',

        detail: 'รายละเอียด',
        condition: 'เงื่อนไขการใช้งาน',

        point: 'คะแนน',
        get_point: 'ได้ ',
        use_point: 'ใช้ ',
        available_date: 'แลกได้วันที่',

        color: {
            name: 'เลือกสี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'เลือกขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
        quantity: 'เลือกจำนวน',
    },
    history: {
        point: 'คะแนน',
        get_point: 'ได้รับ ',
        use_point: 'ใช้คะแนน ',

        parcel_number: 'เลขพัสดุ : ',
        tabbar: {
            earn: 'คะแนนที่ได้รับ',
            used: 'คะแนนที่ใช้ไป',
        },

        list_empty: 'ไม่พบประวัติ',
    },
    terms: {
        headline: 'เงื่อนไขและการใช้งาน'
    },
    aboutus: {
        nav_name: 'เกี่ยวกับเรา',
        headline: 'CPF Feed',
        content: 'ธุรกิจอาหารสัตว์บกดำเนินธุรกิจมาเป็นเวลากว่า 70 ปี นับตั้งแต่ปี พ.ศ.2496 ภายใต้วิสัยทัศน์ “บริการแบบครบวงจร เพื่อสร้างความสำเร็จธุรกิจฟาร์ม” ด้วยพันธุ์สัตว์และอาหารสัตว์คุณภาพดี บริการวิชาการ และเทคโนโลยีจัดการฟาร์ม รวมถึงบริการตลาดรับซื้อผลิตภัณฑ์ เพื่อสร้างความสำเร็จในธุรกิจฟาร์มสุกร สัตว์ปีก ไก่ไข่ เป็ดไข่ ไก่พื้นเมือง และธุรกิจโค ตลอดจนธุรกิจร้านค้าตัวแทนจำหน่าย <br/><br/>ในวันนี้ ธุรกิจอาหารสัตว์บก มีความมุ่งมั่นที่จะส่งมอบคุณค่าทั้งในแง่คุณประโยชน์และสิทธิประโยชน์ต่างๆถึงมือลูกค้าเกษตรกรทุกคน ผ่านเครือข่ายร้านค้าตัวแทนจำหน่ายทั่วประเทศ เราจึงตั้งใจทำระบบสะสมแต้ม CPF Feed Point นี้ขึ้น เพื่อให้แน่ใจว่า ลูกค้าที่ซื้ออาหารสัตว์ของเราทุกถุงได้รับสิทธิประโยชน์และความคุ้มค่า โดยสามารถสะสมคะแนนได้จากการสั่งซื้ออาหารสัตว์ผ่านทางออนไลน์ และคะแนนที่ได้นี้ ยังนำไปใช้แลกของรางวัลได้มากมาย<br/><br/>และนี่คือส่วนหนึ่งของความตั้งใจของเรา ธุรกิจอาหารสัตว์บก ที่จะดูแลลูกค้าทุกคนอย่างดีที่สุด',
        headline_product: 'ผลิตภัณฑ์'
    },
    contactus: {
        nav_name: 'ติดต่อเรา',
        headline_1: 'ด้านผลิตภัณฑ์และบริการของซีพีเอฟ',
        content_1_line_1: 'ติดต่อ หน่วยงานพัฒนากลยุทธ์ธุรกิจ',
        content_1_line_2: 'บริษัท ซีพีเอฟ (ประเทศไทย) จำกัด (มหาชน)',
        content_1_line_3: '128 ถนนเย็นจิต แขวงทุ่งวัดดอน เขตสาทร กรุงเทพฯ 10120',

        headline_2: '',
        content_2_line_1: 'ติดต่อ หน่วยงานพัฒนากลยุทธ์ธุรกิจ',
        content_2_line_2: 'บริษัท ซีพีเอฟ (ประเทศไทย) จำกัด (มหาชน)',
        content_2_line_3: '128 ถนนเย็นจิต แขวงทุ่งวัดดอน เขตสาทร กรุงเทพฯ 10120',

        line_contact: 'Line : @cpffeedonline',
        contact_number: 'โทร : 02-036-4501'
    },
    copy: {
        req_headline: 'ขอรับสำเนาข้อมูลส่วนบุคคล​',
        send_headline: 'ส่งสำเนาข้อมูลส่วนบุคคล<br/>ให้ผู้ควบคุมข้อมูลอื่น',
        name: 'ชื่อ',
        lastname: 'นามสกุล',
        birthday: 'วันเกิด',
        tel: 'เบอร์โทร',
        age: 'อายุ',
        age_detail: 'ฉันมีอายุเกิน 20 ปีบริบูรณ์',
        email_headline: 'กรอกอีเมลสำหรับรับข้อมูล',
        email: {
            name: '',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        pin: 'กำหนดรหัสผ่านในการเปิดไฟล์'
    },
    tabbar: {
        reward: 'สิทธิพิเศษ',
        news: 'ข่าวสาร',
        history: 'ประวัติการใช้',
        profile: 'ข้อมูลส่วนตัว',
    },
    news_list: {
        news_headline: 'ข่าวสารและโปรโมชั่น',
        news_time: '{0} เวลา {1} น.',
        news_empty: 'ไม่พบข่าวสาร'
    },
    home: {
        text_all: 'ดูทั้งหมด',
    },
    reward: {
        title_product: 'ผลิตภัณฑ์ซีพีเอฟ',
        title_privilege: 'สิทธิพิเศษอื่นๆ',
        title_online_catalog: 'สินค้าออนไลน์',
        search_product_placeholder: 'ค้นหาผลิตภัณฑ์ซีพีเอฟ',
        search_privilege_placeholder: 'ค้นหาสิทธิพิเศษ',
        search_online_catalog_placeholder: 'ค้นหาสินค้า',
        reward_empty: 'ไม่พบสิทธิพิเศษ'
    },
    winner:{
        nav_name: 'ประกาศรายชื่อผู้โชคดี',
        label_phone: 'โทร.',
    },
    marketplace:{
        title: 'สินค้าออนไลน์',
    },
    get_friend: {
        invite_title: 'เชิญเพื่อน..รับแต้ม',
        invite_txt_point: 'เชิญเพื่อน 1 คน รับเลย 30 คะแนน',
        invite_txt_max_ppl: 'สูงสุด 3 คน',
        invite_btn: 'ชวนเพื่อนผ่านไลน์',
        friend:"Friend",
        get:"Get",
        get_friend_welcome: 'คุณได้รับเชิญมาเป็นส่วนหนึ่ง',
        get_friend_welcome2: 'ในครอบครัวอาหารสัตว์ซีพีเอฟ',

        get_friend_register: 'สมัครสมาชิก CPF Feed Point',
        get_friend_point: 'รับเลย 100 คะแนน',
        get_friend_register_btn: 'สมัครสมาชิก',
    },
    marketing: {
        title: 'ช่องทางการรับข่าวสาร',
        msg: 'ต้องการรับข้อมูลข่าวสาร',
        all: 'All',
        sms: 'SMS',
        email: 'Email',
        line: 'Line',
        btn: 'บันทึก',
        alert: {
            title: 'บันทึกการรับข่าวสารสำเร็จ',
            msg: 'คุณได้ทำการบันทึกการตั้งค่าข้อมูล<br/>การรับข่าวสารเรียบร้อยแล้ว',
            btn: 'ปิด'
        }
    },
    cookie: {
        title: 'ความยินยอมข้อมูลส่วนบุคคลของคุณ',
        msg: 'บริษัท บัซซี่บีส์ จำกัด ใช้คุกกี้เพื่อมอบประสบการณ์ การใช้งานเว็บไซต์ที่ดีที่สุดให้กับคุณ',
        detail: 'ดูรายละเอียดนโยบายความเป็นส่วนตัว',
        btn: 'ให้ความยินยอมทั้งหมด',
        btn_consent: 'ยอมรับทั้งหมด',
    },
    cookie_consent: {
        title: 'แจ้งเตือนเรื่องคุกกี้',
        text_accept: 'โดยการเข้าใช้เว็บไซต์นี้ ท่านยอมรับเงื่อนไขการใช้คุกกี้ของเรา เราใช้คุกกี้เพียงเพื่อปรับปรุงและเพิ่มประสบการณ์การใช้งานของท่านในเว็บไซต์นี้ ท่านสามารถดู รายละเอียดเพิ่มเติมได้ที่',
        text_cookie: ' นโยบายความเป็นส่วนตัว',
        btn_accept: 'ยอมรับ',
        btn_setting: 'ตั้งค่าความเป็นส่วนตัว',

        cookie_detail: {
            title: 'ความยินยอมข้อมูล<br/>ส่วนบุคคลของคุณ',
            btn_open: 'ดูเพิ่มเติม',
            btn_hide: 'ซ่อนเนื้อหา',
            btn_consent: 'ยินยอม',
            btn_unconsent: 'ไม่ยินยอม',
            btn_accept: 'ยอมรับ',
            btn_close: 'ปิด',
            warning: 'ทางเราอาจจะพัฒนาสินค้าและบริการไม่ตรงตามความต้องการของท่าน โปรดพิจารณา'
        }
    },
    age_consent: {
        title: 'กรุณายืนยันข้อมูลอีกครั้ง',
        msg: 'เนื่องจากการใช้งานแอปพลิเคชันต้อง<br/>มีอายุ 20 ปีบริบูรณ์แล้วเท่านั้น',
        btn: 'ยืนยัน',
        label: 'กรุณากรอกวันเกิด',
        birthdate: {
            name: '',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            day: {
                name: 'วัน',
                placeholder: 'วัน',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            },
            month: {
                name: 'เดือน',
                placeholder: 'เดือน',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            },
            year: {
                name: 'ปี พ.ศ.',
                placeholder: 'ปี พ.ศ.',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            }
        },
        error_age: 'อายุไม่ถึงตามเงื่อนไขที่กำหนด'
    },
    horoscope: {
        title: 'ส่งท้ายปีเก่า ต้อนรับปีใหม่ กับ อ.คฑา',
        burn_btn: 'ดูดวง',
    },
    modal_donate: {
        title: 'ขอบคุณค่ะ',
        msg: 'ขอบคุณที่ร่วมบริจาค',
        close: 'ปิด',
    }
};
